import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Toast } from 'primeng/toast';

@Component({
  selector: 'app-notification-toast',
  template: '<p-toast />',
  imports: [Toast],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppNotificationToast {}
